"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var HomeSlider = /** @class */ (function (_super) {
    __extends(HomeSlider, _super);
    function HomeSlider($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    HomeSlider.prototype.bind = function () {
        this.initYoutube();
        this.initEvtListeners();
    };
    HomeSlider.prototype.initYoutube = function () {
        var self = this;
        $.getScript("//www.youtube.com/player_api", function () {
            var yt_int = setInterval(function () {
                // @ts-ignore
                if (typeof YT === "object") {
                    self.initYT();
                    clearInterval(yt_int);
                }
            }, 500);
        });
    };
    HomeSlider.prototype.initEvtListeners = function () {
        document.querySelectorAll('.contain-slide .mobile-link').forEach(function (element) {
            element.addEventListener('click', function (e) {
                if (window.innerWidth > 767.98) {
                    e.preventDefault();
                }
            });
        });
    };
    HomeSlider.prototype.initYT = function () {
        var self = this;
        var yt_players = {};
        $(".yt-video").each(function () {
            // @ts-ignore
            yt_players[this.id] = new YT.Player(this.id, {
                events: {
                    'onReady': self.onPlayerReady,
                    'onStateChange': self.onPlayerStateChange
                }
            });
        });
    };
    HomeSlider.prototype.onPlayerReady = function (event) {
        $('.carousel').on('slide.bs.carousel', function () {
            event.target.pauseVideo();
        });
    };
    HomeSlider.prototype.onPlayerStateChange = function (event) {
        // @ts-ignore
        if (event.data == YT.PlayerState.PLAYING) {
            // @ts-ignore
            $('.carousel').carousel('pause');
        }
    };
    return HomeSlider;
}(BaseComponent_1.default));
exports.default = HomeSlider;
